var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgH7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.66 24.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-H7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1297516978336",
    "data-name": 1297516978336
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.72v.43C.91,5.32,2.06,8.23,3,9.09c1,.13,2.47-.55,3.48-.7l0,15.48c.12.41.13.27.3.4.32.22,17.61.33,18.08,0,.16-.13.13,0,.27-.31s.05-15,.07-15.57c1,.15,2.52.83,3.47.7.87-.79,2.13-3.8,3-4.94V3.72C31,3,27.81,2,26.62,1.48c-1-.43-4.74-1.82-5.84-1.4-.52.26-.24,1.24-1.76,2.56a5.12,5.12,0,0,1-6.45-.06C11.17,1.35,11.39.34,10.88.08,9.81-.34,6,1.05,5.05,1.47,3.87,2,.65,3,0,3.72Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.74.45a16.67,16.67,0,0,1-5.81,0C13.71,2.87,18,2.88,18.74.45Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgH7);
export default __webpack_public_path__ + "static/media/H7.94c44da55dd6801ec38084d956ec76d5.svg";
export { ForwardRef as ReactComponent };